// EXTERNAL DEPENDENCIES
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

// COMPONENTS
import ButtonWithState from '@/common/components/ui/buttons/button-with-state'

// HELPERS
import {
  updateIsPreviewing,
  updateEditPageErrorMessage,
} from '@/redux/features'
import { useBusinessProfilePageContent } from '../../hooks'

// TEST IDS
import { PREVIEW_PROFILE_BUTTON_TEST_ID } from '../../constants/test-ids'

// STYLES
import styles from './styles.module.less'

/**
 * Displays common Preview button to set isPreviewing to true
 */
export function PreviewProfileButton({
  fpti,
  canPreview,
}: {
  canPreview: boolean
  fpti: string
}) {
  // DECLARATIONS
  const dispatch = useDispatch()
  const getContent = useBusinessProfilePageContent()
  const previewWithExistingErrorToastText = getContent(
    'previewWithExistingErrorToast',
  )

  const [isClicked, setIsClicked] = useState(false)

  const handlePreviewClick = useCallback(() => {
    if (canPreview) {
      dispatch(updateEditPageErrorMessage(''))
      dispatch(updateIsPreviewing(true))
    }
  }, [canPreview, dispatch])

  useEffect(() => {
    if (canPreview === false && isClicked) {
      dispatch(updateEditPageErrorMessage(previewWithExistingErrorToastText))
    }
  }, [canPreview, isClicked, previewWithExistingErrorToastText, dispatch])

  return (
    <ButtonWithState
      secondary
      className={styles.previewButton}
      onClick={handlePreviewClick}
      data-testid={PREVIEW_PROFILE_BUTTON_TEST_ID}
      data-fpti={fpti}
      canProceed={canPreview}
      updateClickStatus={setIsClicked}
    >
      {getContent('preview')}
    </ButtonWithState>
  )
}
